module.exports = __webpack_public_path__ + "media/videos/hiw-video-bc36906479c6797bbd73c3b5e6af8afd.mp4";